import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const PanelPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography>{t("panel.selectSection")}</Typography>
    </>
  );
};

export default PanelPage;
